module.exports = __webpack_public_path__ + "static/media/pizza.eaf90399.gif";